import { useEffect, useState } from 'react';

const DESKTOP_QUERY = '(min-width: 768px)';
const LARGE_SCREEN_QUERY = '(min-width: 1024px)';

function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  );

  useEffect(() => {
    const media = window.matchMedia(query);
    const onChange = () => setMatches(media.matches);
    onChange();
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

export function useIsDesktop(): boolean {
  return useMediaQuery(DESKTOP_QUERY);
}

/** Wide enough for sidebar + document table without horizontal scroll. */
export function useIsLargeScreen(): boolean {
  return useMediaQuery(LARGE_SCREEN_QUERY);
}
